<template>
  <div class="left-panel">
    <SquaresRoad class="first-line-break" :squareNum="blocks.long" />
    <div class="medium-font">Archivo de</div>
    <SquaresRoad :squareNum="4" />
    <div class="big-font">Literatura</div>
    <div class="big-font">Digital</div>
    <div class="medium-font">en</div>
    <div class="big-font">América</div>
    <div class="big-font">Latina</div>
    <SquaresRoad :squareNum="36" />

    <!-- Country -->

    <div class="country">
      <div class="header">
        <span class="italic">País</span>
      </div>
      <div class="content">
        {{ currentCountry }} 
      </div>
    </div>
    <div id="la-map-container"></div>
    <SquaresRoad :squareNum="4" />

    <!-- Genre -->

    <!-- Falta seleccionar genero -->
    <div class="genre">
      <div class="genre-title">
        <span class="italic"> Género </span>
      </div>
      <div class="genre-options">
        <div
          class="genre-option"
          @mouseenter="$emit('genreHighlight', 'Poesía')"
          @mouseleave="$emit('genreUnhighlight')"
          @click="selectGenre('Poesía')"
        >
          <!-- <div class="genre-dot" :class="{red: !(genre === 'Narrativa' || genre === 'Otro')}"></div> -->
          <div class="genre-dot" :class="{red: red}"></div>
          <!-- <span :class="{highlighted: !(genre === 'Narrativa' || genre === 'Otro')}">Poesía</span> -->
          <span :class="{highlighted: (genre === 'Poesía' || genre === 'None')}">Poesía</span>
        </div>
        <div
          class="genre-option"
          @mouseenter="$emit('genreHighlight', 'Narrativa')"
          @mouseleave="$emit('genreUnhighlight')"
          @click="selectGenre('Narrativa')"
        >
          <div class="genre-dot" :class="{blue: blue}"></div>
          <span :class="{highlighted: (genre === 'Narrativa' || genre === 'None')}">Narrativa</span>
        </div>
        <div
          class="genre-option"
          @mouseenter="$emit('genreHighlight', 'Ambos')"
          @mouseleave="$emit('genreUnhighlight')"
          @click="selectGenre('Ambos')"
        >
          <div class="genre-dot" :class="{both: both}"></div>
          <span :class="{highlighted: (genre === 'None' || genre === 'Ambos')}">Ambos</span>
        </div>
        <div
          class="genre-option"
          @mouseenter="$emit('genreHighlight', 'Otro')"
          @mouseleave="$emit('genreUnhighlight')"
          @click="selectGenre('Otro')"
        >
          <div class="genre-dot" :class="{green: green}"></div>
          <span :class="{highlighted: genre === 'Otro' || genre === 'None'}">Otro</span>
        </div>
      </div>
    </div>
    <SquaresRoad :squareNum="4" />

    <!-- Year -->

    <div class="header">
      <span class="italic">Año ({{ 
        years_range[0] != years_range[1] ?
        `${years_range[0]}-${years_range[1]}` : years_range[0] 
        }})</span>
    </div>

    <vue-slider
      class="left-slider"
      v-model="years_range"
      :dot-size="10"
      :absorb="true"
      :dotStyle="sliderStyle"
      :railStyle="railStyle"
      :processStyle="processStyle"
      :data="years"
      :marks="[1980, 1990, 2000, 2010, this.currentYear]"
      :tooltip="'none'"
      @change="(years, k) => selectYears(years)"
    >
    </vue-slider>
    <SquaresRoad :squareNum="blocks.long" />

  </div>
</template>

<script>
import SquaresRoad from '../SquaresRoad.vue';
import * as topojson from 'topojson';
import * as d3 from 'd3';

export default {
  name: 'LeftPanel',
  components: {
    SquaresRoad
  },
  props: [
    'mapJson',
    'genre',
    'country',
    'selection',
  ],
  data() {
    const currentYear = new Date().getFullYear();
    return {
      container: null,
      blocks: {
        long: 70
      },
      sliderStyle: {
        backgroundColor: "var(--black)",
        boxShadow: 'none',
      },
      railStyle: {
        backgroundColor: "var(--black)",
      },
      processStyle: {
        backgroundColor: "var(--black)",
      },
      years_range: [1980, currentYear],
      years: Array.from({length: currentYear - 1980 + 1}, (v, k) => k + 1980),
      currentYear,
    }
  },
  async mounted() {
    this.data = await topojson.feature(this.mapJson, this.mapJson.objects['custom.geo']).features;
    this.projection = await d3.geoMercator();
    this.path = await d3.geoPath().projection(this.projection);
    await this.createMap();
    this.draw();
    this.buildRoad();
  },
  updated() {
    if (this.country.length){
      this.highlight(this.country);
    }
    else {
      this.unhighlight();
    }
  },
  created() {
    window.addEventListener('resize', this.buildRoad());
  },
  methods: {
    createMap() {
      this.container = d3.select('#la-map-container')
        .append('svg')
        .attr('viewBox', '0 0 300 300')
        .append('g')
        .attr('transform', 'translate(-130, -140)');
    },
    draw() {
      this.container.selectAll(".land")
        .data(this.data)
        .enter()
        .append("path")
        .attr("class", "land")
        .attr("d", this.path)
        .style("fill", d => d.properties.admin === "Brazil" ? "white" : "#dfdfdf")
        .style("stroke", "#000")
        .style("stroke-width", "0.5px")
        .on('mouseover', this.recordsCountryHighlight)
        .on('mouseout', this.recordsCountryUnhighlight)
        .on('click', this.selectCountry);
    },
    highlight(country) {
      this.container
        .selectAll(".land")
        .transition()
        .duration(200)
        .style("fill", d => (d.properties.admin === country.normalize("NFD").replace(/[\u0300-\u036f]/g, "")) ? "black" : (d.properties.admin === "Brazil") ? "white" : "#dfdfdf");
    },
    unhighlight() {
      this.container
        .selectAll(".land")
        .transition()
        .duration(200)
        .style("fill", d => d.properties.admin === "Brazil" ? "#fffbf8" : "#dfdfdf");
    },
    buildRoad() {
      if (this.$el) {
        this.blocks.long = Math.floor(this.$el.clientWidth / 3.5);
      }
    },
    recordsCountryHighlight(d){
      this.highlight(d.properties.admin);
      this.$emit('hover', 'country', d.properties.admin);
    },
    recordsCountryUnhighlight(){
      this.unhighlight();
      this.$emit('unhover');
    },
    selectCountry(d){
      this.$emit('select', 'country', d.properties.admin);
    },
    selectGenre(genre){
      this.$emit('select', 'genre', genre);
    },
    selectYears(years){
      this.$emit('select', 'years', years);
    },
    cleanSelection(){
      this.years_range = [1980, this.currentYear];
    }
  },
  computed: {
    red: function(){
      return (this.genre === 'Poesía' || this.genre === 'None');
    },
    green: function(){
      return this.genre === 'Otro' || this.genre === 'None';
    },
    blue: function(){
      return this.genre === 'Narrativa' || this.genre === 'None';
    }, 
    both: function(){
      return this.genre === 'Ambos' || this.genre === 'None';
    },
    currentCountry: function() {
      return this.selection.country ? this.selection.country : this.country;
    },
  },
  watch: {

  },
}
</script>

<style scoped>

  .left-panel {
    font-family: var(--courier);
    width: 100%;
  }

  #la-map-container {
    width: 60%;
  }

  .italic {
    font-style: italic;
  }

  .country .content {
    height: 20px;
  }

  .genre .genre-title {
    margin-bottom: 5px;
  }

  .genre-option {
    width: 100%;
    display: flex;
    justify-content: left;
    margin: 3px 0px;
    cursor: pointer;
  }

  .genre-option span {
    color: #e0e0df;
  }

  .genre-option span.highlighted {
    color: black;
  }

  .genre-dot {
    margin-left: 10px;
    margin-right: 10px;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    background-color: #dddddd;
  }

  .genre-dot.red {
    background-color: #993300;
  }

  .genre-dot.blue {
    background-color: #2aafda;
  }

  .genre-dot.both {
    background: linear-gradient(90deg, #993300 50%, #2aafda 50%);
  }

  .genre-dot.green {
    background-color: #2a803e;
  }

  @media only screen and (min-height: 725px) {
    .medium-font {
      font-size: 28px;
      line-height: 32px;
    }

    .big-font {
      font-size: 28px;
      line-height: 32px;
    }

    .genre {
      font-size: 20px;
    }

    .country {
      font-size: 20px;
    }

    .header {
      font-size: 20px;
    }

    .first-line-break {
      padding-bottom: 15px;
    }
  }

  @media only screen and (max-height: 725px) {
    .medium-font {
      font-size: 20px;
      line-height: 24px;
    }

    .big-font {
      font-size: 20px;
      line-height: 24px;
    }

    .genre {
      font-size: 14px;
    }

    .country {
      font-size: 14px;
    }

    .header {
      font-size: 20px;
    }

    .first-line-break {
      padding-bottom: 5px;
    }
  }

  .medium-font {
    font-family: var(--vesper);
    font-weight: 500;
  }

  .big-font {
    font-family: var(--vesper);
    font-weight: 900;
    text-transform: uppercase;
  }

  .left-slider {
    margin: 3% 0% 10% 0%;
  }

  .vue-slider-dot-handle {
    box-shadow: none !important;
  }

</style>
